/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Container,
  Dropdown,
  Modal,
  Badge,
  Form,
  InputGroup,
  Spinner,
  Pagination,
  Alert,
} from "@themesberg/react-bootstrap";

import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { apiURL, deleteApi, fetchApi, postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faEdit,
  faEye,
  faListUl,
  faPlus,
  faTrash,
  faSearch,
  faFilter,
  faSync,
  faCalendarAlt,
  faFileAlt,
  faMoneyBillWave,
  faCheckCircle,
  faClock,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { useSelector } from "react-redux";
import useQuery from "../../../hooks/useQuery";
import { SearchContext } from "../../HomePage";
import SearchInput from "../../../components/SearchInput";
import { Col, Form as BootstrapForm, Row } from "react-bootstrap";
import moment from "moment";

function PVCollectionIndex({ match, type = null }) {
  const history = useNavigate();
  const location = useLocation();
  const query = useQuery()
  const pageMode = query.get('page-mode')
  const isReview = location.pathname.includes("review-index");
  const isApprove = location.pathname.includes("approve-index");
  const user = useSelector((state) => state.auth.user);
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif"];
  
  // Enhanced state management
  const [filterText, setFilterText] = useState("");
  const [pvList, setPvList] = useState([]);
  const [approvalList, setApprovalList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const today = moment().format("YYYY-MM-DD")
  const aMonthAgo = moment(today).subtract(1, 'month').format("YYYY-MM-DD")
  
  // Filter states
  const [statusFilter, setStatusFilter] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [dateFrom, setDateFrom] = useState(aMonthAgo);
  const [dateTo, setDateTo] = useState(today);
  const [amountFrom, setAmountFrom] = useState("");
  const [amountTo, setAmountTo] = useState("");
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  
  // Modal states
  const [modal, setModal] = useState(false);
  const [attachmentModalIsOpen, setAttachmentModalIsOpen] = useState(false);
  const [selectedPV, setSelectedPvNo] = useState("");
  const [pvImageInfo, setPvImageInfo] = useState([]);
  const [item, setItem] = useState({});
  const [_delete, setDelete] = useState(false);
  
  const { searchTerm, setSearchTerm } = useContext(SearchContext);

  const toggleDelete = (item) => {
    setItem(item);
    setDelete(!_delete);
  };

  const attachmentModalToggle = () => {
    setAttachmentModalIsOpen((p) => !p);
  };

  const viewAttachment = (imageid, pv) => {
    setSelectedPvNo(pv);
    fetchApi(`fetch-pv-images?pv_no=${imageid}`).then((resp) => {
      attachmentModalToggle();
      if (resp.results && resp.results.length) {
        setPvImageInfo(resp.results);
      } else {
        setPvImageInfo({});
      }
    });
  };

  // Enhanced data fetching
  const fetchApprovalList = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      
      const response = await postApi(`post_approval_collection`, {
        form: {
          query_type: "by_mda",
          filter: "Approval Processed",
          mda_name: user?.mda_name,
          mda_code: user?.mda_code,
        },
      });
      
      if (response?.result?.length) {
        setApprovalList(response.result);
      } else {
        setApprovalList([]);
      }
    } catch (err) {
      console.error("Error fetching approval list:", err);
      setError("Failed to load approval data. Please try again.");
      setApprovalList([]);
    } finally {
      setLoading(false);
    }
  }, [user?.mda_name, user?.mda_code]);

  const fetchPvList = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      
      const response = await postApi(`get_pv_collection`, {
        form: {
          query_type: "pv_by_mda",
          pv_status: "Created - Returned",
          mda_name: user?.mda_name, 
          mda_code: user?.mda_code || "",
        },
      });
      
      if (response?.result?.length) {
        const processedData = response.result.map(item => ({
          ...item,
          isOpen: false,
          formatted_date: moment(item.date).format('DD/MM/YYYY'),
          formatted_amount: formatNumber(item.amount)
        }));
        setPvList(processedData);
      } else {
        setPvList([]);
      }
    } catch (err) {
      console.error("Error fetching PV list:", err);
      setError("Failed to load PV data. Please try again.");
      setPvList([]);
    } finally {
      setLoading(false);
    }
  }, [user?.mda_name, user?.mda_code]);

  // Enhanced filtering function
  const applyFilters = useCallback(() => {
    const pageIsRelease = !pageMode || pageMode === 'releases';
    const sourceData = pageIsRelease ? approvalList : pvList;
    
    let filtered = [...sourceData];
    
    // Text search filter
    if (filterText.trim()) {
      const searchLower = filterText.toLowerCase();
      filtered = filtered.filter(item => 
        item.approval_no?.toLowerCase().includes(searchLower) ||
        item.mda_name?.toLowerCase().includes(searchLower) ||
        item.approval_type?.toLowerCase().includes(searchLower) ||
        item.narration?.toLowerCase().includes(searchLower)
      );
    }
    
    // Global search term filter
    if (searchTerm.trim()) {
      const globalSearchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(item => 
        item.approval_no?.toLowerCase().includes(globalSearchLower) ||
        item.mda_name?.toLowerCase().includes(globalSearchLower) ||
        item.approval_type?.toLowerCase().includes(globalSearchLower)
      );
    }
    
    // Status filter
    if (statusFilter !== "All") {
      filtered = filtered.filter(item => {
        const status = pageIsRelease ? item.approval_status : item.status;
        return status?.toLowerCase().includes(statusFilter.toLowerCase());
      });
    }
    
    // Type filter
    if (typeFilter !== "All") {
      filtered = filtered.filter(item => 
        item.approval_type?.toLowerCase().includes(typeFilter.toLowerCase())
      );
    }
    
    // Date range filter
    if (dateFrom) {
      filtered = filtered.filter(item => {
        const itemDate = moment(item.date);
        return itemDate.isSameOrAfter(moment(dateFrom), 'day');
      });
    }
    
    if (dateTo) {
      filtered = filtered.filter(item => {
        const itemDate = moment(item.date);
        return itemDate.isSameOrBefore(moment(dateTo), 'day');
      });
    }
    
    // Amount range filter
    if (amountFrom) {
      filtered = filtered.filter(item => 
        parseFloat(item.amount || 0) >= parseFloat(amountFrom)
      );
    }
    
    if (amountTo) {
      filtered = filtered.filter(item => 
        parseFloat(item.amount || 0) <= parseFloat(amountTo)
      );
    }
    
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  }, [approvalList, pvList, filterText, searchTerm, statusFilter, typeFilter, dateFrom, dateTo, amountFrom, amountTo, pageMode]);

  // Clear all filters
  const clearFilters = () => {
    setFilterText("");
    setStatusFilter("All");
    setTypeFilter("All");
    setDateFrom("");
    setDateTo("");
    setAmountFrom("");
    setAmountTo("");
    setSearchTerm("");
  };

  // Refresh data
  const refreshData = () => {
    const pageIsRelease = !pageMode || pageMode === 'releases';
    if (pageIsRelease) {
      fetchApprovalList();
    } else {
      fetchPvList();
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Get unique values for filter dropdowns
  const getUniqueStatuses = () => {
    const pageIsRelease = !pageMode || pageMode === 'releases';
    const sourceData = pageIsRelease ? approvalList : pvList;
    const statuses = sourceData.map(item => 
      pageIsRelease ? item.approval_status : item.status
    ).filter(Boolean);
    return [...new Set(statuses)];
  };

  const getUniqueTypes = () => {
    const pageIsRelease = !pageMode || pageMode === 'releases';
    const sourceData = pageIsRelease ? approvalList : pvList;
    const types = sourceData.map(item => item.approval_type).filter(Boolean);
    return [...new Set(types)];
  };

  // Effects
  useEffect(() => {
    if (user?.mda_name) {
      fetchApprovalList();
      fetchPvList();
    }
  }, [user, fetchApprovalList, fetchPvList]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  // Enhanced table fields
  const fields = [
    {
      title: "Action",
      custom: true,
      component: (item, index) => (
        <Button
          size="sm"
          variant="primary"
          onClick={() =>
            history(
              `${Routes.pv.newPv}?approval_no=${encodeURIComponent(item.approval_no)}&approval_type=${encodeURIComponent(item.approval_type)}&pv_code=${encodeURIComponent(item.pv_code || '')}`
            )
          }
        >
          <FontAwesomeIcon icon={faPlus} className="me-1" />
          Generate PV
        </Button>
      ),
    },
    {
      title: "Approval No.",
      value: "approval_no",
      sortable: true,
    },
    {
      title: "Approval Type",
      value: "approval_type",
      sortable: true,
    },
    {
      title: "Status",
      custom: true,
      component: (item) => {
        const status = item.approval_status;
        let variant = "secondary";
        if (status?.includes("Processed")) variant = "success";
        else if (status?.includes("Pending")) variant = "warning";
        else if (status?.includes("Return")) variant = "danger";
        
        return (
          <Badge bg={variant}>
            {status}
          </Badge>
        );
      },
    },
    {
      title: "Date",
      custom: true,
      component: (item) => (
        <div>
          <FontAwesomeIcon icon={faCalendarAlt} className="me-1 text-muted" />
          {moment(item.date).format('DD/MM/YYYY')}
        </div>
      ),
      sortable: true,
    },
    {
      title: "Amount (₦)",
      custom: true,
      component: (item) => (
        <div className="text-end">
          <FontAwesomeIcon icon={faMoneyBillWave} className="me-1 text-success" />
          {formatNumber(item.amount)}
        </div>
      ),
      sortable: true,
    },
  ];

  const pvFields = [
    {
      title: "Action",
      custom: true,
      component: (item, index) => (
        <ButtonGroup size="sm">
          <Button
            variant="outline-primary"
            onClick={() => {
              history(
                `${Routes.pv.viewPvGenerated}?approval_no=${encodeURIComponent(item.approval_no)}&approval_type=${encodeURIComponent(item.approval_type || '')}&pv_code=${encodeURIComponent(item.pv_code || '')}`
              );
            }}
          >
            <FontAwesomeIcon icon={faEye} className="me-1" />
            View
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() =>
              history(
                `${Routes.pv.editnewPv}?approval_no=${encodeURIComponent(item.approval_no)}&approval_type=${encodeURIComponent(item.approval_type || '')}&pv_code=${encodeURIComponent(item.pv_code || '')}`
              )
            }
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" />
            Edit
          </Button>
        </ButtonGroup>
      ),
    },
    {
      title: "Approval No.",
      value: "approval_no",
      sortable: true,
    },
    {
      title: "PV Code",
      value: "pv_code",
      sortable: true,
    },
    {
      title: "Number of PVs",
      custom: true,
      component: (item) => (
        <div className="text-center">
          <Badge bg="info">{item.no_of_pvs || 1}</Badge>
        </div>
      ),
    },
    {
      title: "Status",
      custom: true,
      component: (item) => {
        const status = item.status;
        let variant = "secondary";
        let icon = faClock;
        
        if (status?.includes("Return")) {
          variant = "warning";
          icon = faExclamationTriangle;
        } else if (status?.includes("Approved")) {
          variant = "success";
          icon = faCheckCircle;
        }
        
        return (
          <Badge bg={variant}>
            <FontAwesomeIcon icon={icon} className="me-1" />
            {status}
          </Badge>
        );
      },
    },
    {
      title: "Date",
      custom: true,
      component: (item) => (
        <div>
          <FontAwesomeIcon icon={faCalendarAlt} className="me-1 text-muted" />
          {moment(item.date).format('DD/MM/YYYY')}
        </div>
      ),
      sortable: true,
    },
    {
      title: "Amount (₦)",
      custom: true,
      component: (item) => (
        <div className="text-end">
          <FontAwesomeIcon icon={faMoneyBillWave} className="me-1 text-success" />
          {formatNumber(item.amount)}
        </div>
      ),
      sortable: true,
    },
  ];

  const pageIsRelease = !pageMode || pageMode === 'releases';
  const pageIsPv = pageMode && pageMode === 'pvs';

  return (
    <>
      {/* Header */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>
            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
            {pageIsRelease ? "Pending Releases" : "Returned PVs"}
          </h4>
          <p className="mb-0 text-muted">
            {pageIsRelease 
              ? "Manage and generate PVs from approved releases" 
              : "Review and edit returned payment vouchers"
            }
          </p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={refreshData}
            disabled={loading}
            className="me-2"
          >
            <FontAwesomeIcon icon={faSync} className={`me-1 ${loading ? 'fa-spin' : ''}`} />
            Refresh
          </Button>
        </div>
      </div>

      {/* Tab Navigation */}
      <Card className="mb-4">
        <Card.Body className="p-3">
          <ButtonGroup style={{ width: '100%' }}>
            <Button 
              onClick={() => history(`${Routes.pv.pvlIndex}?page-mode=releases`)} 
              variant={pageIsRelease ? 'primary' : "outline-primary"}
              className="d-flex align-items-center justify-content-center"
            >
              <FontAwesomeIcon icon={faListUl} className="me-2" />
              Pending Releases
              <Badge bg="light" text="dark" className="ms-2">
                {approvalList.length}
              </Badge>
            </Button>
            <Button 
              onClick={() => history(`${Routes.pv.pvlIndex}?page-mode=pvs`)} 
              variant={pageIsPv ? 'primary' : "outline-primary"}
              className="d-flex align-items-center justify-content-center"
            >
              <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
              Returned PVs
              <Badge bg="light" text="dark" className="ms-2">
                {pvList.length}
              </Badge>
            </Button>
          </ButtonGroup>
        </Card.Body>
      </Card>

      {/* Enhanced Filters */}
      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0">
            <FontAwesomeIcon icon={faFilter} className="me-2" />
            Filters & Search
          </h6>
          <Button variant="outline-secondary" size="sm" onClick={clearFilters}>
            Clear All
          </Button>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Search</BootstrapForm.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <BootstrapForm.Control
                    type="text"
                    placeholder="Search approval no, MDA, type..."
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </InputGroup>
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Status</BootstrapForm.Label>
                <BootstrapForm.Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="All">All Statuses</option>
                  {getUniqueStatuses().map(status => (
                    <option key={status} value={status}>{status}</option>
                  ))}
                </BootstrapForm.Select>
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Type</BootstrapForm.Label>
                <BootstrapForm.Select
                  value={typeFilter}
                  onChange={(e) => setTypeFilter(e.target.value)}
                >
                  <option value="All">All Types</option>
                  {getUniqueTypes().map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </BootstrapForm.Select>
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Date From</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Date To</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </BootstrapForm.Group>
            </Col>
          </Row>
          {/* <Row>
            <Col md={3}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Amount From (₦)</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="number"
                  placeholder="Minimum amount"
                  value={amountFrom}
                  onChange={(e) => setAmountFrom(e.target.value)}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={3}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Amount To (₦)</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="number"
                  placeholder="Maximum amount"
                  value={amountTo}
                  onChange={(e) => setAmountTo(e.target.value)}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={6} className="d-flex align-items-end">
              <div className="text-muted">
                <small>
                  Showing {currentItems.length} of {filteredData.length} records
                  {filteredData.length !== (pageIsRelease ? approvalList.length : pvList.length) && 
                    ` (filtered from ${pageIsRelease ? approvalList.length : pvList.length} total)`
                  }
                </small>
              </div>
            </Col>
          </Row> */}
        </Card.Body>
      </Card>

      {/* Error Alert */}
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError("")}>
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
          {error}
        </Alert>
      )}

      {/* Data Table */}
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2">Loading data...</div>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
              <div className="text-center text-muted">
                <FontAwesomeIcon icon={faFileAlt} size="3x" className="mb-3" />
                <h5>No records found</h5>
                <p>
                  {(filterText || statusFilter !== "All" || typeFilter !== "All" || dateFrom || dateTo || amountFrom || amountTo)
                    ? "Try adjusting your filters to see more results."
                    : `No ${pageIsRelease ? 'pending releases' : 'returned PVs'} available.`
                  }
                </p>
              </div>
            </div>
          ) : (
            <CustomTable
              fields={pageIsRelease ? fields : pvFields}
              data={currentItems}
            />
          )}
        </Card.Body>

        {/* Pagination */}
        {totalPages > 1 && (
          <Card.Footer className="px-3 border-0 d-flex align-items-center justify-content-between">
            <small className="fw-bold">
              Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
            </small>
            <Pagination className="mb-0">
              <Pagination.Prev 
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              />
              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                if (
                  pageNumber === 1 ||
                  pageNumber === totalPages ||
                  (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                ) {
                  return (
                    <Pagination.Item
                      key={pageNumber}
                      active={pageNumber === currentPage}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </Pagination.Item>
                  );
                } else if (
                  pageNumber === currentPage - 3 ||
                  pageNumber === currentPage + 3
                ) {
                  return <Pagination.Ellipsis key={pageNumber} />;
                }
                return null;
              })}
              <Pagination.Next 
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              />
            </Pagination>
          </Card.Footer>
        )}
      </Card>

      {/* Modals */}
      <Modal show={attachmentModalIsOpen} onHide={attachmentModalToggle} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
            PV Attachments - {selectedPV}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Container>
            <div className="image-container">
              {pvImageInfo.length ? (
                pvImageInfo.map((item, index) =>
                  imageExtensions.some((extension) =>
                    item.image_url.toLowerCase().endsWith(extension)
                  ) ? (
                    <Card.Img
                      key={index}
                      top
                      src={`${apiURL}/uploads/${item.image_url}`}
                      alt={"pv"}
                      className="mb-3"
                      style={{ maxHeight: "400px", objectFit: "contain" }}
                    />
                  ) : (
                    <Card.Body key={index}>
                      <Card.Link
                        href={`${apiURL}/uploads/${item.image_url}`}
                        target="_blank"
                        className="btn btn-outline-primary"
                      >
                        <FontAwesomeIcon icon={faEye} className="me-2" />
                        View PDF Document
                      </Card.Link>
                    </Card.Body>
                  )
                )
              ) : (
                <div className="text-muted">
                  <FontAwesomeIcon icon={faFileAlt} size="3x" className="mb-3" />
                  <h5>No attachments found</h5>
                </div>
              )}
            </div>
          </Container>
        </Modal.Body>
      </Modal>

      <Modal show={_delete} onHide={toggleDelete}>
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faTrash} className="me-2 text-danger" />
            Confirm Deletion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="mb-3">
            <FontAwesomeIcon icon={faExclamationTriangle} size="3x" className="text-warning" />
          </div>
          <h5>Are you sure you want to delete PV: {item.pv_code}?</h5>
          <p className="text-muted">This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={toggleDelete}>
            Cancel
          </Button>
          <Button
            variant="danger"
            // onClick={handleDelete}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Deleting...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faTrash} className="me-2" />
                Delete
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PVCollectionIndex;
